module.exports = __webpack_public_path__ + "img/icon-upload-file.6ffe28da.svg";